import primaryComponents from "../../../../primaryComponents";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import styles from "./styles.module.scss";
import { ArrowRight, ExclamationCirlce } from "../../../../../assets/svgIcons";

export const AudienceSummary = ({
  formData = {},
  isSubmitting = false,
  onSubmit = () => {},
}) => {
  const totalManualNumbers =
    formData?.recipient_phone_numbers === ""
      ? 0
      : formData?.recipient_phone_numbers?.split(",")?.length || 0;
  const totalAudience = formData?.no_of_audience || 0;
  const totalPhoneContact = formData?.select_all_customers
    ? (formData?.total_customers || 0) - formData?.exclude_customer_ids?.length
    : formData?.customer_ids?.length || 0;

  return (
    <div
      className={`${globalStyles["cardWithBackground"]} ${styles.audienceSummary}`}
    >
      <div>
        <div className="d-flex justify-content-between">
          <h6>Audience Summary</h6>
          <ExclamationCirlce width="25px" height="25px" />
        </div>
        <hr />
      </div>

      <div>
        <p>TOTAL RECIPIENTS</p>
        <h2 className="purple--text mt-2">
          {totalPhoneContact + totalAudience + totalManualNumbers}
          <span className="default-font-size gray--text font-weight-normal">
            contacts
          </span>
        </h2>
      </div>

      <ul>
        <div className={styles.audience}>
          <li>Manual Entry</li>
          <span>{totalManualNumbers}</span>
        </div>

        <div className={styles.audience}>
          <li>Segment</li>
          <span>{totalAudience}</span>
        </div>

        <div className={styles.audience}>
          <li>Phone Book</li>
          <span>{totalPhoneContact}</span>
        </div>
      </ul>

      <primaryComponents.Button
        classNames={"btn btn--primary"}
        isDisabled={isSubmitting}
        isLoading={isSubmitting}
        loadingText={"Processing..."}
        onClick={() => onSubmit()}
      >
        Next: Content <ArrowRight className="ml-1" />
      </primaryComponents.Button>
    </div>
  );
};
